import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe with proper error handling
let stripePromise = null;

const initializeStripe = () => {
  const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
  
  if (!publishableKey) {
    console.error(
      '❌ Stripe Error: Missing REACT_APP_STRIPE_PUBLISHABLE_KEY environment variable.\n' +
      'Please add it to your .env file and restart the development server.'
    );
    return null;
  }
  
  return loadStripe(publishableKey);
};

stripePromise = initializeStripe();

export default stripePromise;